import {
    TransferSchedule,
    TransferScheduleStatus
} from "@/shared/types";

export function isScheduleCancelledOrCompleted (schedule: TransferSchedule): boolean {
    return isScheduleCancelled(schedule) || isScheduleCompleted(schedule.status);
}

export function isScheduleCancelled (schedule: TransferSchedule): boolean {
    return schedule.status === TransferScheduleStatus.Cancelled;
}

export function isScheduleCompleted (status: TransferScheduleStatus): boolean {
        // Revisions should be displayed as completed
    return status === TransferScheduleStatus.Revised
        || status === TransferScheduleStatus.Completed;
}